export const login = user => ({
  type: 'LOGIN',
  user
});

export const logout = () => ({
  type: 'LOG_OUT',
});
